import { Button, Card, CardBody } from 'react-bootstrap'
import { Bilancia } from '../../types'
import { UseQueryResult } from '@tanstack/react-query'
import { useRef } from 'react'
import { transformDownloadUrl } from '../../utils/utils'
import {
  useAllegatiBilancia,
  useCreateAllegatoBilancia,
  useDeleteAllegatoBilancia,
  usePartialUpdateBilancia,
} from '../../hooks/bilance'
import { toast } from 'react-toastify'
import MaterialIcon from '../../components/MaterialIcon'

export default function CardAllegatiBilancia({
  bilancia,
}: {
  bilancia: UseQueryResult<Bilancia, Error>
}) {
  const fotoTargaInputRef = useRef<HTMLInputElement>(null)
  const allegatoBilanciaInputRef = useRef<HTMLInputElement>(null)
  const { mutateAsync: updatePartialBilancia } = usePartialUpdateBilancia()
  const { mutateAsync: addAllegatoBilancia } = useCreateAllegatoBilancia()
  const { mutateAsync: deleteAllegatoBilancia } = useDeleteAllegatoBilancia()
  const allegatiBilancia = useAllegatiBilancia({
    bilancia: String(bilancia.data?.id),
  })
  return (
    <Card className="mt-3 mb-3">
      <CardBody>
        <div className="py-1 border-bottom">
          <div className="d-flex justify-content-between">
            <h4 className="heading-h4 d-flex align-items-center">
              <span className="material-icons text-secondary me-2">folder</span>
              Allegati bilancia
            </h4>
            <div className="d-flex align-items-center">
              {!bilancia.data?.foto_targa && (
                <Button
                  variant="outline-secondary"
                  size="sm"
                  className="text-secondary d-flex align-items-center"
                  onClick={() => {
                    fotoTargaInputRef.current?.click()
                  }}
                >
                  <span className="material-icons">attach_file</span>
                  <span className="ms-2">Aggiungi foto targa</span>
                </Button>
              )}
              <Button
                variant="outline-secondary"
                size="sm"
                className="text-secondary d-flex align-items-center ms-2"
                onClick={() => {
                  allegatoBilanciaInputRef.current?.click()
                }}
              >
                <span className="material-icons">attach_file</span>
                <span className="ms-2">Aggiungi allegato</span>
              </Button>
            </div>
          </div>
        </div>
        <div className="mt-3 d-flex align-items-center">
          {bilancia.data?.foto_targa ||
          allegatiBilancia.data?.results.length ? (
            <table className="table">
              <thead>
                <tr>
                  <th>Preview</th>
                  <th>Nome file</th>
                  <th>Azioni</th>
                </tr>
              </thead>
              <tbody>
                {bilancia.data?.foto_targa && (
                  <tr>
                    <td>
                      {bilancia?.data?.foto_targa ? (
                        <a
                          href={transformDownloadUrl(
                            bilancia?.data?.foto_targa as string
                          )}
                          target="_blank"
                        >
                          <img
                            src={
                              typeof bilancia?.data?.foto_targa === 'string'
                                ? transformDownloadUrl(
                                    bilancia?.data?.foto_targa
                                  )
                                : bilancia?.data?.foto_targa
                                ? URL.createObjectURL(
                                    bilancia?.data?.foto_targa
                                  )
                                : ''
                            }
                            alt="Foto targa"
                            width="80"
                          />
                        </a>
                      ) : (
                        <MaterialIcon icon="image" />
                      )}
                    </td>
                    <td style={{ maxWidth: 290, width: 290 }}>
                      {typeof bilancia?.data?.foto_targa === 'string'
                        ? bilancia?.data?.foto_targa
                            .split('/')
                            .pop()
                            ?.split('?')[0]
                        : bilancia?.data?.foto_targa?.name.split('?')[0]}
                    </td>
                    <td>
                      <div className="d-flex">
                        <Button
                          size="sm"
                          variant="secondary"
                          className="text-white d-flex align-items-center me-2"
                          onClick={() => {
                            fotoTargaInputRef.current?.click()
                          }}
                        >
                          <span
                            className="material-icons"
                            style={{
                              fontSize: 20,
                            }}
                          >
                            upload
                          </span>
                        </Button>
                        <Button
                          size="sm"
                          variant="outline-secondary"
                          className="d-flex align-items-center"
                          onClick={() => {
                            typeof bilancia?.data?.foto_targa === 'string' &&
                              window.open(bilancia?.data?.foto_targa)
                          }}
                        >
                          <span
                            className="material-icons me-2"
                            style={{
                              fontSize: 16,
                            }}
                          >
                            download
                          </span>
                          Scarica
                        </Button>
                      </div>
                    </td>
                  </tr>
                )}
                {allegatiBilancia.data?.results.map((allegato) => (
                  <tr key={allegato.id}>
                    <td>
                      {allegato.allegato ? (
                        <a
                          href={transformDownloadUrl(
                            allegato.allegato as string
                          )}
                          target="_blank"
                        >
                          <MaterialIcon icon="attach_file" fontSize={40} />
                        </a>
                      ) : (
                        <MaterialIcon icon="attach_file" fontSize={40} />
                      )}
                    </td>
                    <td style={{ maxWidth: 290 }}>
                      {typeof allegato.allegato === 'string'
                        ? allegato.allegato.split('/').pop()?.split('?')[0]
                        : allegato.allegato?.name.split('?')[0]}
                    </td>
                    <td>
                      <div className="d-flex">
                        <Button
                          size="sm"
                          variant="secondary"
                          className="text-white d-flex align-items-center me-2"
                          onClick={() => {
                            deleteAllegatoBilancia(allegato.id).then(() => {
                              toast.success('Allegato eliminato con successo', {
                                position: 'bottom-right',
                                autoClose: 5000,
                                hideProgressBar: false,
                                closeOnClick: true,
                                pauseOnHover: true,
                                draggable: true,
                                progress: undefined,
                              })
                            })
                          }}
                        >
                          <span
                            className="material-icons"
                            style={{
                              fontSize: 20,
                            }}
                          >
                            delete
                          </span>
                        </Button>
                        <Button
                          size="sm"
                          variant="outline-secondary"
                          className="d-flex align-items-center"
                          onClick={() => {
                            typeof allegato.allegato === 'string' &&
                              window.open(allegato.allegato)
                          }}
                        >
                          <span
                            className="material-icons me-2"
                            style={{
                              fontSize: 16,
                            }}
                          >
                            download
                          </span>
                          Scarica
                        </Button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          ) : (
            <div>Nessun allegato presente</div>
          )}
          <input
            ref={fotoTargaInputRef}
            type="file"
            className="d-none"
            accept="image/*"
            onChange={async (e) => {
              if (e.target.files && e.target.files[0]) {
                await updatePartialBilancia({
                  id: bilancia?.data?.id,
                  foto_targa: e.target.files[0],
                })
                  .then(() => {
                    toast.success('Foto targa aggiunta con successo', {
                      position: 'bottom-right',
                      autoClose: 5000,
                      hideProgressBar: false,
                      closeOnClick: true,
                      pauseOnHover: true,
                      draggable: true,
                      progress: undefined,
                    })
                  })
                  .finally(() => {
                    e.target.value = ''
                  })
              }
            }}
          />
          <input
            ref={allegatoBilanciaInputRef}
            type="file"
            className="d-none"
            onChange={async (e) => {
              if (e.target.files && e.target.files[0]) {
                await addAllegatoBilancia({
                  bilancia: bilancia?.data?.id,
                  allegato: e.target.files[0],
                })
                  .then(() => {
                    toast.success('Allegato aggiunto con successo', {
                      position: 'bottom-right',
                      autoClose: 5000,
                      hideProgressBar: false,
                      closeOnClick: true,
                      pauseOnHover: true,
                      draggable: true,
                      progress: undefined,
                    })
                  })
                  .finally(() => {
                    e.target.value = ''
                  })
              }
            }}
          />
        </div>
      </CardBody>
    </Card>
  )
}
